import React, { useState, useMemo } from "react";
import { Form, Table, Row, Col, Button } from "react-bootstrap";
import Layout from "../../layout/Layout";
import "../../styles/StandardDocument.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import goktasLogo from "../../../assets/gs_logo_net.png";

function UKkota() {
  const [parsedData, setParsedData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const formatNumber = (val) => {
    if (val === "" || val == null || isNaN(val)) return "";
    return Number(val).toLocaleString("en-US");
  };

  const formatPercent = (val) => {
    if (val === "" || val == null || isNaN(val)) return "";
    return parseFloat(val).toFixed(2);
  };

  const productList = useMemo(
    () => [
      "Alloy merchant bars and light sections",
      "Angles and sections",
      "Gas pipes",
      "Hollow sections",
      "Large welded tubes - A",
      "Large welded tubes - B",
      "Metallic coated sheets",
      "Non alloy and alloy hot rolled sheets",
      "Non-alloy and other alloy cold finished bars",
      "Non alloy and other alloy wire rod",
      "Non-alloy merchant bars and light sections",
      "Non-alloy wire",
      "Organic coated sheets",
      "Other welded pipes",
      "Quarto plates",
      "Railway material",
      "Rebars",
      "Stainless bars and light sections",
      "Stainless wire rod",
      "Tin mill products",
    ],
    []
  );

  const countryList = useMemo(
    () => [
      "All Countries",
      "China",
      "India",
      "Japan",
      "Other",
      "South Korea",
      "Taiwan",
      "Turkey",
      "United Arab Emirates",
      "European Union",
    ],
    []
  );

  // 📥 Excel import
  const handleExcelImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames?.[0];
        const sheet = workbook.Sheets[firstSheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });

        const grouped = [];
        let currentGroup = null;

        rows.forEach((r) => {
          const [colA, colB, colC] = r;

          // Başlık satırı (Boşlukları trim() ile temizliyoruz ki filtre tam eşleşsin)
          if (
            (colA?.toString().trim() || "") &&
            (!colB || colB === "") &&
            (!colC || colC === "")
          ) {
            currentGroup = { title: colA.toString().trim(), data: [] };
            grouped.push(currentGroup);
            return;
          }

          if (!currentGroup) return;

          currentGroup.data.push({
            country: (r[0] || "").toString().trim(), // Boşlukları temizliyoruz
            code: r[1] || "",
            startDate: r[2] || "",
            endDate: r[3] || "",
            amount: r[4] || "",
            balance: r[5] || "",
            usedVolume: r[6] || "",
            usedPercent: r[7] || "",
            lastAllocation: r[8] || "",
          });
        });

        setParsedData(grouped);
        setSelectedProducts(productList);
        setSelectedCountries(countryList);
      } catch (err) {
        console.error("❌ Excel okuma hatası:", err);
        alert("Excel okunamadı, dosya yapısını kontrol et.");
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleProductSelect = (p) =>
    setSelectedProducts((prev) =>
      prev.includes(p) ? prev.filter((x) => x !== p) : [...prev, p]
    );

  const handleCountrySelect = (c) =>
    setSelectedCountries((prev) =>
      prev.includes(c) ? prev.filter((x) => x !== c) : [...prev, c]
    );

  // Filtreleme (Sadece eşleşen verileri alır ve içi boşalan grupları komple gizler)
  const filteredData = parsedData
    .filter((t) => selectedProducts.includes(t.title))
    .map((t) => ({
      ...t,
      data: t.data.filter((r) => selectedCountries.includes(r.country)),
    }))
    .filter((t) => t.data.length > 0); // Altında hiç veri kalmayan tabloyu çöpe atar

  const exportToPDF = () => {
    if (!filteredData || filteredData.length === 0) {
      return alert("⚠️ Export edilecek veri bulunamadı!");
    }

    const doc = new jsPDF("landscape");
    let startY = 15;

    // Tabloları Çizdirme Döngüsü
    filteredData.forEach((group) => {
      // Başlığı bas
      doc.setFontSize(11);
      doc.setTextColor(40);
      doc.text(group.title, 14, startY);
      startY += 5;

      // BUNU DEĞİŞTİRDİK: doc.autoTable yerine dışarıdan autoTable çağırıyoruz ve ilk parametre olarak doc veriyoruz.
      autoTable(doc, {
        startY: startY,
        head: [
          [
            "Country",
            "Code",
            "Start Date",
            "End Date",
            "Amount",
            "Balance",
            "Used Vol.",
            "Used (%)",
            "Last Alloc.",
          ],
        ],
        body: group.data.map((item) => [
          item.country,
          item.code,
          item.startDate,
          item.endDate,
          formatNumber(item.amount),
          formatNumber(item.balance),
          formatNumber(item.usedVolume),
          formatPercent(item.usedPercent),
          item.lastAllocation,
        ]),
        theme: "grid",
        headStyles: { fillColor: [48, 84, 150], halign: "center" },
        columnStyles: {
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
          7: { halign: "right" },
        },
        styles: { fontSize: 8, cellPadding: 2 },
      });

      // Bir sonraki tablo için Y koordinatını güncelle
      startY = doc.lastAutoTable.finalY + 15;
      // Bir sonraki tablo için Y koordinatını güncelle
      startY = doc.lastAutoTable.finalY + 15;

      // Eğer sayfa sonuna geldiysek yeni sayfa aç
      if (startY > doc.internal.pageSize.getHeight() - 20) {
        doc.addPage();
        startY = 15;
      }
    });

    // BÜTÜN SAYFALARA LOGOYU WATERMARK (FİLİGRAN) OLARAK BAS
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);

      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();

      // Logonun boyutları
      const logoW = 100;
      const logoH = 100;
      const x = (pdfWidth - logoW) / 2;
      const y = (pdfHeight - logoH) / 2;

      doc.setGState(new doc.GState({ opacity: 0.1 }));

      doc.addImage(goktasLogo, "PNG", x, y, logoW, logoH);

      doc.setGState(new doc.GState({ opacity: 1 }));
    }

    doc.save(`SteelOne_CPlan_UK_${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">SteelOne C Planı UK</h2>

      <Row className="align-items-center mb-4">
        <Col md={4}>
          <Form.Group>
            <Form.Label className="fw-bold">Excel Dosyası Yükle</Form.Label>
            <Form.Control
              type="file"
              accept=".xlsx,.xls"
              onChange={handleExcelImport}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Button variant="danger" onClick={exportToPDF}>
            📄 PDF’e Aktar
          </Button>
        </Col>
      </Row>

      {parsedData.length > 0 && (
        <>
          <Row className="mb-4">
            <Col md={5}>
              <h5 className="fw-bold">Products</h5>
              <div
                style={{
                  height: "160px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "5px",
                }}
              >
                {productList.map((p) => (
                  <Form.Check
                    key={p}
                    type="checkbox"
                    label={p}
                    checked={selectedProducts.includes(p)}
                    onChange={() => handleProductSelect(p)}
                    style={{ fontSize: "13px", margin: "3px" }}
                  />
                ))}
              </div>
            </Col>

            <Col md={5}>
              <h5 className="fw-bold">Countries</h5>
              <div
                style={{
                  height: "160px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "5px",
                }}
              >
                {countryList.map((c) => (
                  <Form.Check
                    key={c}
                    type="checkbox"
                    label={c}
                    checked={selectedCountries.includes(c)}
                    onChange={() => handleCountrySelect(c)}
                    style={{ fontSize: "13px", margin: "3px" }}
                  />
                ))}
              </div>
            </Col>

            <Col md={2} className="d-flex flex-column justify-content-end">
              <Button
                className="mb-2"
                variant="secondary"
                onClick={() => {
                  setSelectedProducts(productList);
                  setSelectedCountries(countryList);
                }}
              >
                Tümünü Seç
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => {
                  setSelectedProducts([]);
                  setSelectedCountries([]);
                }}
              >
                Temizle
              </Button>
            </Col>
          </Row>

          {filteredData.map((sheet, index) => (
            <div key={index} className="mb-5">
              <h5 className="fw-bold mb-3">{sheet.title}</h5>
              <div className="table-responsive">
                <Table striped bordered hover size="sm">
                  <thead className="table-secondary">
                    <tr>
                      <th>Country</th>
                      <th>Code</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th className="text-end">Amount</th>
                      <th className="text-end">Balance</th>
                      <th className="text-end">Used Volume</th>
                      <th className="text-end">Used (%)</th>
                      <th>Last Allocation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sheet.data.map((row, i) => (
                      <tr key={i}>
                        <td>{row.country}</td>
                        <td>{row.code}</td>
                        <td>{row.startDate}</td>
                        <td>{row.endDate}</td>
                        <td className="text-end">{formatNumber(row.amount)}</td>
                        <td className="text-end">
                          {formatNumber(row.balance)}
                        </td>
                        <td className="text-end">
                          {formatNumber(row.usedVolume)}
                        </td>
                        <td className="text-end">
                          {formatPercent(row.usedPercent)}
                        </td>
                        <td>{row.lastAllocation}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ))}
        </>
      )}
    </Layout>
  );
}

export default UKkota;
